<template>
  <TheGreyWrapper>
    <TheHeader
      back-route="accept"
      force-sm-style
    />
    <BaseSection v-if="opportunity">
      <BaseTitleGroup
        :title="$t('Investment entity choice')"
        :subtitle="opportunity.data.attributes.name"
        class="mb-8"
      />
      <BaseRadioButtons
        :items="formattedList"
        :add-text="$t('Add a new investment entity')"
        :on-add="onAdd(undefined)"
        v-model="chosenEntity"
        class="mb-6"
      >
        <BaseRadioButton
          slot-scope="slotProps"
          :active="slotProps.active"
        >
          <template v-if="slotProps.item.kind == 'Company'">
            {{ slotProps.item.companyType }} {{ slotProps.item.lastname }}
            <br>
            {{ slotProps.item.address }}, {{ slotProps.item.zipCode }} {{ slotProps.item.city }}
          </template>
          <template v-else>
            {{ slotProps.item.firstname }} {{ slotProps.item.lastname }}
            <br>
            {{ slotProps.item.address }}, {{ slotProps.item.zipCode }} {{ slotProps.item.city }}
          </template>
        </BaseRadioButton>
      </BaseRadioButtons>
      <BaseButton
        :title="$t('Confirm')"
        :theme="buttonTheme"
        class="mb-8"
        @click.native="submitEntity"
      />
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loadOpportunity from '../mixins/loadOpportunity';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseRadioButtons from '../components/BaseRadioButtons.vue';
import BaseRadioButton from '../components/BaseRadioButton.vue';
import BaseButton from '../components/BaseButton.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';

export default {
  name: 'InvestmentEntityChoice',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseRadioButtons,
    BaseRadioButton,
    BaseButton,
    TheGreyWrapper,
  },
  mixins: [loadOpportunity],
  data() {
    return {
      chosenEntity: null,
    };
  },
  computed: {
    ...mapState('investmentEntity', ['list']),
    formattedList() {
      return this.list.map(item => item.attributes);
    },
    buttonTheme() {
      if (!this.chosenEntity) {
        return 'disabled';
      }
      return null;
    },
    opportunityId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.fetchList().then((response) => {
      if (!response.data.data.length) {
        this.onAdd(1)();
      } else {
        this.chosenEntity = this.list[0].attributes;
      }
    });
  },
  methods: {
    ...mapActions('investmentEntity', ['fetchList', 'chooseEntity']),
    onAdd(fromOpportunity) {
      const path = `/opportunities/${this.opportunityId}/investment-entities/new`;
      return () => this.$router.push({ path, query: { fromOpportunity } });
    },
    submitEntity() {
      this.chooseEntity({
        opportunityId: this.opportunityId,
        chosenEntityId: this.chosenEntity.id,
      }).then(() => {
        const url = `/opportunities/${this.opportunityId}/investment-entities/confirmation`;
        this.$router.push(url);
      });
    },
  },
};
</script>
